

<template>

</template>
<script  >
export  default {
  data(){
    return{
      allItem: [
        { label: "خط مشی", value: "خط مشی" },
        { label: "آیین نامه", value: "آیین نامه" },
        { label: "نظامنامه", value: "نظامنامه" },
        { label: "روش اجرایی", value: "روش اجرایی" },
        { label: "دستور العمل", value: "دستور العمل" },
        { label: "مدارک طرح ریزی", value: "مدارک طرح ریزی" },
        { label: "فرم ها", value: "فرم ها" },
        { label: "برون سازمانی", value: "برون سازمانی" }
      ],
      search: '',
      selectedItems: [],
      allItem_organization: [],
      search_organization: '',
      selected_organization: [],
    }
  },
  computed: {
    filteredItems() {
      const search = this.search.trim().toLowerCase();
      if (search === '') {
        return this.allItem;
      } else {
        return this.allItem.filter(item => item.label.toLowerCase().includes(search));
      }
    },

  }




}
</script>
<style scoped>

</style>